<template>
    <div class="service-periodical-search-box">
        <div class="icon-drag-show"></div>
        <div class="container">
            <div class="row justify-content-center set-mg-top">
                <div class="col-12 col-md-6">
                    <h1 class="subscribe-title-noinline">
                        ค้นหารายการ<br class="d-block d-xl-none" /><span class="t-inline"
                            >บำรุงรักษา<span class="t-inline">ตามระยะทาง</span></span
                        >
                    </h1>

                    <p class="sub-text-in-section">
                        การนำรถยนต์เข้าศูนย์บริการ หรือ การเช็คระยะรถยนต์ เป็นขั้นตอนสำคัญในการดูแลรักษารถ เพื่อยืดอายุการใช้งาน
                        เพิ่มประสิทธิภาพในการขับขี่ และเพิ่มความปลอดภัยในการใช้รถยนต์ กรอกข้อมูลรถยนต์ของคุณในแบบฟอร์มด้านบน
                        เพื่อประเมินการเช็กระยะรถยนต์ว่ามีราคาเท่าไรในแต่ละรายการบำรุงรักษาตามระยะทาง
                    </p>

                    <p class="subscribe-subtitle">
                        เพื่อประเมินราคาอะไหล่<span class="t-inline">และค่าบริการ</span><br class="d-block d-xl-none" />สำหรับรถยนต์ของคุณ
                    </p>
                </div>
            </div>

            <div class="row justify-content-center">
                <div class="col-12 col-md-6">
                    <form action="" method="GET" class="periodical_model_search">
                        <div class="main-box-search">
                            <div class="box-search-in">
                                <div id="select-model" class="search-title">
                                    รุ่นรถ
                                </div>
                                <div class="periodical_field">
                                    <v-select
                                        :searchable="false"
                                        v-model="model"
                                        :options="dataModels"
                                        label="name"
                                        @input="findYear"
                                        placeholder="กรุณาเลือกรุ่นรถ"
                                    >
                                    </v-select>
                                </div>
                                <div>
                                    <!-- <div :disabled="(model==null)" v-b-toggle.collapse-1 class="menu-text-list"> -->
                                    <div disabled id="select-year" class="menu-text-list" :class="{ 'eff-showselect': collapse1 }">
                                        <div>ปีรถ <span class="text-rad" :class="{ setcolor: collapse1 }">(กรุณาเลือกปีรถ)</span></div>
                                        <img
                                            class="icon-arrow"
                                            :class="{ ro90: collapse1 }"
                                            :src="asset('images/chevron-right-grey.svg')"
                                            alt=""
                                        />
                                    </div>
                                    <b-collapse id="collapse-1" v-model="collapse1">
                                        <div class="row no-gutters year_row">
                                            <div class="col-6 col-md-6 year_col" v-for="(yearName, index) in dataYears" :key="index">
                                                <div
                                                    class="btn btn-secondary year_btn"
                                                    :class="{ 'btn-primary': years == yearName }"
                                                    @click="getYear(yearName)"
                                                >
                                                    <span>{{ yearName }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </b-collapse>

                                    <!-- <div :disabled="(years==null)" v-b-toggle.collapse-2 class="menu-text-list"> -->
                                    <div disabled id="select-engine" class="menu-text-list" :class="{ 'eff-showselect': collapse2 }">
                                        <div>
                                            เครื่องยนต์
                                            <span class="text-rad" :class="{ setcolor: collapse2 }">(กรุณาเลือกเครื่องยนต์)</span>
                                        </div>
                                        <img
                                            class="icon-arrow"
                                            :class="{ ro90: collapse2 }"
                                            :src="asset('images/chevron-right-grey.svg')"
                                            alt=""
                                        />
                                    </div>
                                    <b-collapse id="collapse-2" v-model="collapse2">
                                        <div class="">
                                            <div
                                                class="btn btn-secondary engine_btn"
                                                :class="{ 'btn-primary': engine == dataEngine.id }"
                                                v-for="(dataEngine, index) in dataEngines"
                                                :key="index"
                                                @click="getEngine(dataEngine.id, dataEngine.name)"
                                            >
                                                <span>{{ dataEngine.name }}</span>
                                            </div>
                                        </div>
                                    </b-collapse>

                                    <!-- <div :disabled="(engine==null)" v-b-toggle.collapse-3 class="menu-text-list"> -->
                                    <div disabled class="menu-text-list" :class="{ 'eff-showselect': collapse3 }">
                                        ระยะทาง
                                        <img
                                            class="icon-arrow"
                                            :class="{ ro90: collapse3 }"
                                            :src="asset('images/chevron-right-grey.svg')"
                                            alt=""
                                        />
                                    </div>
                                    <b-collapse id="collapse-3" v-model="collapse3">
                                        <v-select
                                            :searchable="false"
                                            v-model="distance"
                                            :options="dataDistances"
                                            label="name"
                                            :reduce="distance => distance.value"
                                            placeholder="กรุณาเลือกระยะทาง"
                                            @input="getDistance(distance)"
                                        >
                                        </v-select>
                                    </b-collapse>
                                </div>
                                <button
                                    type="button"
                                    variant="primary"
                                    class="btn btn-primary set-btn-center setbt-w gtm-service-btn-search"
                                    :class="{ 'btn-disbled': btn == null }"
                                    :disabled="btn == null"
                                    @click="submitFinde"
                                >
                                    <span v-if="clickSubmitFinde" class="setloading"
                                        ><b-spinner small type="grow"></b-spinner> Loading...</span
                                    >
                                    <span v-else class="btn-search">ค้นหา</span>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
    data() {
        return {
            model: null,
            dataYears: null,
            years: null,
            dataEngines: null,
            engine: null,
            enginname: null,
            dataDistances: [],
            distance: null,
            btn: null,
            collapse1: false,
            collapse2: false,
            collapse3: false,
            clickSubmitFinde: false
        };
    },
    props: {
        dataModels: {
            type: Array,
            default: null
        },
        dataTableservices: {
            type: Object,
            default: null
        },
        dataHead: {
            type: Object,
            defualt: null
        }
    },
    methods: {
        setDatadistance() {
            let km = 10000;
            for (let i = 0; i < 20; i++) {
                let option = {
                    value: km,
                    name: Number(km).toLocaleString()
                };
                this.dataDistances.push(option);
                km = km + 10000;
            }
        },
        findYear(value) {
            const self = this;
            axios
                .get("/api/getYear/" + value.id)
                .then(response => {
                    this.dataYears = response.data;
                    this.btn = null;
                    this.collapse1 = false;
                    this.collapse2 = false;
                    this.collapse3 = false;
                    this.distance = null;

                    this.$root.dataTableservices = null;
                    this.cleardata();
                    if (this.collapse1 == false) {
                        this.collapse1 = true;
                    }
                    this.$nextTick(() => {
                        self.$parent.updateGuideline();
                        this.$root.scrollToShowModel(); //scrollTo section
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getYear(value) {
            this.years = value;
            this.findEngine(this.years);
            this.$root.scrollToShowYear(); //scrollTo section
        },
        findEngine(value) {
            const self = this;
            console.log(value);
            axios
                .get("/api/model/" + this.model.id + "/getEngine/" + value)
                .then(response => {
                    this.dataEngines = response.data;
                    this.collapse3 = false;
                    this.engine = null;
                    this.distance = null;
                    this.btn = null;
                    this.$root.dataTableservices = null;

                    if (this.collapse2 == false) {
                        this.collapse2 = true;
                    }
                    this.$nextTick(() => {
                        self.$parent.updateGuideline();
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getEngine(value, name) {
            const self = this;
            this.engine = value;
            this.enginename = name;
            this.distance = null;
            this.btn = null;
            this.$root.dataTableservices = null;

            if (this.collapse3 == false) {
                this.collapse3 = true;
            }
            this.$nextTick(() => {
                // will run after $emit is done
                // container.scrollTop =  0;
                self.$parent.updateGuideline();
                this.$root.scrollToShowEngine(); //scrollTo section
            });
        },
        getDistance(value) {
            this.btn = "ok";
            this.$parent.distanceSelect = value;
            // this.$nextTick(() => {
            //     // will run after $emit is done
            //     this.$root.scrollToShowDistance();  //scrollTo section
            // })
        },
        submitFinde() {
            this.clickSubmitFinde = true;

            const self = this;
            this.$root.setfc(this.model.id, this.engine, this.distance, this.years, this.model.name, this.enginename);
            let dataall = {
                namemodel: this.model,
                engine: this.enginename,
                year: this.years,
                distance: this.distance
            };
            axios({
                method: "post",
                url: "/api/getMaintenance",
                data: {
                    id: this.model.id,
                    engine: this.engine,
                    year: this.years,
                    distance: this.distance
                }
            })
                .then(response => {
                    /// CDP Tracking ///
                    analytics.track("Periodical Maintenance Search", {
                        car_model: dataall.namemodel.name,
                        car_year: dataall.year,
                        car_engine: dataall.engine,
                        mile: dataall.distance,
                        ...findCarCategory(dataall.namemodel.name),
                        created_date: moment().format("YYYY-MM-DD HH:mm:ss")
                    });
                    // Gtag Tracking //
                    gtag("event", "page periodical maintenance", {
                        model_name: dataall.namemodel.name,
                        action_type: "click on page",
                        action_label: "model select",
                        section_name: ""
                    });
                    this.$emit("update:dataHead", dataall);
                    this.$emit("update:dataTableservices", response.data);
                    this.$root.scrollIntoTop(); //scrollTo show table result section
                    this.$nextTick(() => {
                        // will run after $emit is done
                        this.clickSubmitFinde = false;
                        self.$parent.updateGuideline();
                    });
                })
                .catch(error => {
                    console.log(error);
                });
        },
        cleardata() {
            const self = this;
            // this.model =null;
            this.years = null;
            this.engine = null;
            this.distance = null;

            this.$nextTick(() => {
                // will run after $emit is done
                self.$parent.updateGuideline();
            });
        }
    },
    mounted() {
        this.setDatadistance();
    }
};
</script>

<style lang="scss" scoped>
.service_page {
    .btn-secondary {
        color: #fff;
        border: solid 0px;

        &::before {
            background: #ec1b2e;
        }
        span {
            position: relative;
            z-index: 10;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/service/SearchService.vue